import { create } from "zustand";
import { Product } from "../types/product";
import productsData from "../demo/products.json"; // Assuming your JSON is here
import { executeFetch } from "../helper/Api";
import Cookies from 'js-cookie';
interface ProductStore {
  products: Product[];
  selectedProduct : Product | null;
  fetchProducts: (filters : ProductFilters) => Promise<void>;
  getProductBySku: (id: string) => Promise<void>;
  getFeaturedProducts: () => Product[];
  sortProductsByPrice: (products: Product[], order: 'asc' | 'desc') => Product[];
  sortProductsByName: (products: Product[], order: 'asc' | 'desc') => Product[];
}
interface ProductFilters{
  brandId : string | null;
  categoryId : string | null;
}



const useProductStore = create<ProductStore>((set, get) => ({
  products: [],
  selectedProduct:null,
  error: null,

  fetchProducts: async (filters : ProductFilters) => {
    try {
      let resp =null;
      const hasToken = Cookies.get('token') !== undefined;
      if(hasToken){
        resp = await executeFetch<Product[]>(`Products/GetProductsCus?categoryId=${filters.categoryId}&brandId=${filters.brandId}`,{auth:'auth'})
      }else{
        resp = await executeFetch<Product[]>(`Products/GetProducts?categoryId=${filters.categoryId}&brandId=${filters.brandId}`)
      }
  
      if(resp.error){
        console.error(resp.error.message)
     }else{
      set({ products: resp.data as Product[]});
     }
     
    } catch (error) {
      console.error("Error fetching products:", error);
    }
  },
  getProductBySku: async (code: string) => {
    try {
      let resp =null;
      const hasToken = Cookies.get('token') !== undefined;
      if(hasToken){
        resp = await executeFetch<Product[]>(`Products/GetProductBySkuCus/${code}`,{auth:'auth'})
      }else{
        resp = await executeFetch<Product>(`Products/GetProductBySku/${code}`)
      }
    
      if(resp.error){
        console.error(resp.error.message)
     }else{
      set({ selectedProduct: resp.data as Product});
     }
    } catch (error) {
      console.error("Error fetching product:", error);
    }
  },
  sortProductsByPrice: (products: Product[], order: 'asc' | 'desc') => {
    return [...products].sort((a, b) => 
      order === 'asc' ? a.b2cPrice - b.b2cPrice : b.b2cPrice - a.b2cPrice
    );
  },
  sortProductsByName: (products: Product[], order: 'asc' | 'desc') => {
    return [...products].sort((a, b) =>
      order === 'asc' 
        ? a.name.localeCompare(b.name) 
        : b.name.localeCompare(a.name)
    );
  },
  getFeaturedProducts: () => {
    return get().products
      .filter(product => product.salesPercentage > 0)
      .sort((a, b) => b.salesPercentage - a.salesPercentage)
      .slice(0, 8); // Get top 8 featured products
  }
}));

export default useProductStore;